import { Route } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { initialDataResolver } from './app.resolvers';
import { NoAuthGuard } from './_helper/auth/guards/noAuth.guard';
import { AuthGuard } from './_helper/auth/guards/auth.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

function getHomeRoute() {
  let brand = window.location.hostname.split('.');

  return brand[0].includes('fieldpal') ? 'schedule/schedule' : 'home';
}
export const appRoutes: Route[] = [
  // Redirect empty path to '/home'
  { path: '', pathMatch: 'full', redirectTo: getHomeRoute() },

  // Redirect signed in user to the '/home'
  //
  // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
  // path. Below is another redirection for that path to redirect the user to the desired
  // location. This is a small convenience to keep all main routes together here on this file.
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: getHomeRoute() },

  // Mobile User (Xamrine App Routes)
  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'mobile-user/forgot-password',
        loadChildren: () => import('app/mobileusers/mobile-user-forgot-password/forgot-password.routes'),
      },
      {
        path: 'mobile-user/reset-password',
        loadChildren: () => import('app/mobileusers/mobile-user-reset-password/reset-password.routes'),
      },
    ],
  },
  // Auth routes for guests
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'forgot-password',
        loadChildren: () => import('app/auth/forgot-password/forgot-password.routes'),
      },
      {
        path: 'reset-password',
        loadChildren: () => import('app/auth/reset-password/reset-password.routes'),
      },
      {
        path: 'sign-in',
        loadChildren: () => import('app/auth/sign-in/sign-in.routes'),
      },
      {
        path: 'verify-newaccount',
        loadChildren: () => import('app/auth/verify-new-account/verify-new-account.routes'),
      },
    ],
  },

  // Auth routes for authenticated users
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'sign-out',
        loadChildren: () => import('app/auth/sign-out/sign-out.routes'),
      },
      {
        path: 'change-password-sign-in',
        loadChildren: () => import('app/auth/change-password-sign-in/change-password-sign-in.routes'),
      },
    ],
  },

  // Admin routes
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: 'home',
        loadChildren: () => import('app/home/example/example.routes'),
      },
      {
        path: 'mediamanagement',
        loadChildren: () => import('app/file-manager/file-manager.routes'),
      },
      {
        path: 'notificationhistory',
        loadChildren: () => import('app/notificationhistory/notificationhistory.routes'),
      },
      {
        path: 'jobs',
        loadChildren: () => import('app/jobs/jobs.routes'),
      },
      // {
      //   path: 'job',
      //   loadChildren: () => import('app/jobcreate/job.routes'),
      // },
      {
        path: 'forms',
        loadChildren: () => import('app/forms/form.routes'),
      },
      {
        path: 'catalogues',
        loadChildren: () => import('app/catalogues/catalogue.routes'),
      },
      {
        path: 'change-password',
        loadChildren: () => import('app/auth/change-password/change-password.routes'),
      },
      {
        path: 'reports',
        loadChildren: () => import('app/reports/customreports.routes'),
      },
      {
        path: 'schedule',
        loadChildren: () => import('app/schedule/schedule.routes'),
      },
      {
        path: 'mobileuser-list',
        loadChildren: () => import('app/mobileusers/mobileusers-list/mobileusers-list.routes'),
      },
      {
        path: 'users-list',
        loadChildren: () => import('app/users/users-list/users-list.routes'),
      },
      {
        path: 'external',
        loadChildren: () => import('app/external/external.routes'),
      },
      {
        path: 'template',
        loadChildren: () => import('app/record-templates/record-templates.routes'),
      },
    ],
  },

  // Error
  {
    path: 'error',
    children: [
      {
        path: '404',
        loadChildren: () => import('app/pages/error/error-404/error-404.routes'),
      },
      {
        path: '500',
        loadChildren: () => import('app/pages/error/error-500/error-500.routes'),
      },
    ],
  },
  {
    path: '404-not-found',
    pathMatch: 'full',
    loadChildren: () => import('app/pages/error/error-404/error-404.routes'),
  },
  { path: '**', redirectTo: '404-not-found' },
];
